import styled from '../../theme/styled-with-theme';
import { mediaQueries } from '../../styles/media-queries';
import { ParagraphWithLineBreaks } from '../RichText/styles';
import { Flexbox } from '../Flexbox';

export const DisclosureParagraph = styled(ParagraphWithLineBreaks)`
  text-align: center;
  ${({ theme }) => ({ marginTop: theme.spacing.m })};
  ${({ theme }) => ({ fontSize: theme.fontSize['2xs'] })};

  ${mediaQueries.tablet} {
    ${({ theme }) => ({ fontSize: theme.fontSize.sm })};
  }
`;

export const CtaWrapper = styled(Flexbox)`
  width: 100%;
`;

export const PrivacyWrapper = styled(Flexbox)`
  width: calc(10 / 12 * 100%);
  align-self: center;
`;
